export default __webpack_public_path__ + "static/BannerUspAndTitle-d614d50ba0d9460a8550aad6dd1d98a6.jpg";